import * as React from 'react'

import Link from 'next/link'

// allow this component to accept all properties of "a" tag
interface Props extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  to: string
  shallow?: boolean
  as?: string
  // we can add more properties we need from next/link in the future
  [props: string]: any
}

// Forward Refs, is useful
const CustomLink = ({ to, shallow, as, ...props }: Props, ref: any) => {
  return <Link href={to} shallow={shallow} as={as} {...props} ref={ref} />
}

export default React.forwardRef(CustomLink)
